import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Box, DialogTitle} from "@material-ui/core";
import {DashboardStyles} from "../../../styles/dashboard";
import {connect} from "react-redux";

const useStyles = makeStyles(DashboardStyles);

const MessageSuccessModal = (props) => {
    const classes = useStyles();
    return (
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title" PaperProps={{ classes: {root: classes.dialogPaper } }}>
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}  disableTypography>Message Sent</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.dialogText}>Thanks for messaging Carwiser, a representative will reach out to you as soon as possible!</Box>

            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button  size={"small"} color="primary"   variant="contained"  onClick={props.handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );

}


const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageSuccessModal);
